import { Drawer, type DrawerProps, useTheme } from '@mui/material';
export type CustomDrawerPT = DrawerProps & { handleClose?: () => void }
export const CustomDrawer = (props: CustomDrawerPT) => {
  const { sx, ...rest } = props;
  const theme = useTheme();
  return (
    <Drawer
      anchor={'bottom'}
      sx={{
        '& .MuiDrawer-paper': {
          background: theme.palette.bg,
          p: 14,
          borderRadius: '54px 54px 0 0',
        },
        ...sx,
      }}
      {...rest}
    />
  );
};